<section class="will-be-able">
    <div class="container">
        <div class="will-be-able-card">
            <div class="row">
                <div class="col-md-5">
                    <div class="section-title">Players Will Be Able</div>
                </div>
                <div class="col-md-6">
                    <div class="text">Lock LIS tokens in staking and take part in management voting.</div>
                    <div class="text">Lock LIS tokens in staking to receive weekly rewards based on the amount of LIS
                        spent in games and a portion of the reserved tokens.
                    </div>
                    <div class="text">Earn LIS tokens by qualifying and winning tournaments.</div>
                    <div class="text">Use LIS tokens for all in-game transactions. Game operations will receive revenues
                        from Realis and all future games in the ecosystem, the fund will be managed by a team at an
                        early stage and redistribute the obtained assets within the entire ecosystem.
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<style>
    .will-be-able {
        margin: 120px 0;
    }

    .will-be-able-card {
        background: #373737;
        border-radius: 12px;
        padding: 25px;
    }

    .section-title {
        color: white;
        font-family: "Echoes Sans", sans-serif;
        text-align: left;
        margin-top: 172px;
        border: 2px solid #FF5D1C;
        display: inline-block;
        padding: 25px 35px;
        font-size: 36px;
        border-radius: 12px;
    }

    .text {
        font-size: 20px;
        color: white;
        font-weight: 400;
        line-height: 1.4;
        background: rgba(255, 255, 255, 0.1);
        border-radius: 12px;
        padding: 10px 15px;
        margin: 10px 0;
    }

    .will-be-able hr {
        background: #3D3D44;
        opacity: 1;
    }

    @media (max-width: 1200px) {
        .section-title {
            margin-top: 240px;
            padding: 20px;
            font-size: 30px;
            line-height: 36px;
        }
    }

    @media (max-width: 992px) {
        .will-be-able .section-title {
            font-size: 28px;
            line-height: normal;
        }
    }

    @media (max-width: 767px) {
        .will-be-able {
            margin: 60px 0 40px;

        }

        .will-be-able-card {
            padding: 20px;
            margin: 0 -12px;
            border-radius: 0;
        }

        .text {
            font-size: 16px;
            line-height: 21.86px;
        }

        .will-be-able .section-title {
            font-size: 24px;
            line-height: normal;
            margin: 10px 0 20px;
            width: 100%;
            text-align: center;
            padding: 15px;
        }
    }
</style>
